module.exports = __webpack_public_path__ + "img/archive.6a0dc3c5.svg";